// extracted by mini-css-extract-plugin
module.exports = {"externalVideoLink":"style-module_externalVideoLink__3zjC8-ft4rjRPprQU2bHBP"};